import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { NavLink } from 'react-router-dom';
import { formatUserListDate as formatDate } from 'utils/date';
import { hasText } from 'utils/hasText';
import { ROUTES, insertIdtoUrl } from '../../constants/Routes';

const DEFAULT_PAGE_SIZE = 20;

const UsersList = props => {
  const { users, searchText } = props;

  let searchedUsers = users.slice();

  searchedUsers = searchedUsers.filter(user => {
    const searchValues = [user.first_name, user.last_name, user.email];
    const isVisible = hasText(searchValues, searchText);

    return isVisible;
  });

  const columns = [
    {
      Header: 'Name',
      sortable: true,
      id: 'name',
      acessor: 'name',
      Cell: ({ original }) => {
        const { first_name, middle_name, last_name, id } = original;

        return (
          <NavLink to={insertIdtoUrl(ROUTES.USER_SHOW, id)}>
            {first_name || ''} {middle_name || ''} {last_name || ''}
          </NavLink>
        );
      },
    },
    {
      Header: 'Email Address',
      sortable: true,
      accessor: 'email',
      width: 300,
    },
    {
      id: 'business',
      sortable: true,
      Header: 'Business Account',
      Cell: ({ original }) => {
        const { business } = original;
        const { id, name } = business;

        return (
          <NavLink to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, id)}>
            {name}
          </NavLink>
        );
      },
    },

    {
      id: 'userSince',
      sortable: true,
      Header: 'User Since',
      accessor: d => formatDate(new Date(d.created_at)),
    },
    {
      id: 'lastLogin',
      sortable: true,
      Header: 'Last Login',
      accessor: d => formatDate(new Date(d.last_login)),
    },
    {
      id: 'loginCount',
      sortable: true,
      Header: 'Login Count',
      accessor: 'login_count',
    },
  ];

  const pageSize =
    searchedUsers.length === 0 || searchedUsers.length > DEFAULT_PAGE_SIZE
      ? DEFAULT_PAGE_SIZE
      : searchedUsers.length;
  const minRows = searchedUsers.length ? 0 : 2;

  return (
    <ReactTable
      className="styled-box-shadow bg-white"
      data={searchedUsers}
      columns={columns}
      resizable={false}
      sortable={false}
      showPageSizeOptions={false}
      minRows={minRows}
      defaultPageSize={pageSize}
    />
  );
};

UsersList.defaultProps = {
  users: [],
  searchText: '',
};

UsersList.propTypes = {
  users: PropTypes.shape([]),
  searchText: PropTypes.string,
};

export default UsersList;



// WEBPACK FOOTER //
// ./src/components/users/UsersList.js